export const DEFAULT_HEIGHT = '225';
export const DEFAULT_WIDTH = '400';
